<!-- <section class="vh-100" id="backg">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100" id="row-flex">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5" id="sesion">
        <div class="card shadow-2-strong" id="card_shadow">
          <div class="card-body p-5 text-center">
            <form method="post">-->
             <!--  <h3 class="mb-5">Inicio de sesión</h3> -->
              <!--<div class="form-outline mb-4">-->
                <!-- <label class="form-label" for="usuario">Número Docente</label> -->
               <!-- <input type="text" id="usuario" name="usuario" [(ngModel)]="usuario"  class="form-control form-control-lg" placeholder="Número Docente"/>
              </div>

              <div class="form-outline mb-4">-->
                <!-- <label class="form-label" for="passw">Contraseña</label> -->
               <!-- <input [type]="showPwd ? 'text' : 'password'" id="passw" name="passw" [(ngModel)]="passw" class="form-control form-control-lg" placeholder="Contraseña" />
              </div>
              <a id="verpwd" (click)="mostrarPwd()">{{showPwd ? 'Ocultar' : 'Mostrar'}} contraseña</a>

              <button id="btn-submit" class="btn-lg btn-block mt-3" type="submit" (click)="login()"><b>Entrar</b></button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->
<section class="vh-100" style="background-color: #CED5DD;">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col col-xl-10">
        <div class="card" style="border-radius: 1rem;">
          <div class="row g-0">
            <div class="col-md-6 col-lg-5 d-none d-md-block">
              <img src="assets/ImagenLogin.svg"
                alt="login form" class="img-fluid" style="border-radius: 1rem 0 0 1rem;" />
            </div>
            <div class="col-md-6 col-lg-7 d-flex align-items-center">
              <div class="card-body p-4 p-lg-5 text-black">
                <form>
                  <div class="d-flex align-items-center mb-3 pb-1">
                    <a class="navbar-brand" href="#"><img src="assets/ulsap.svg" alt="La salle pachuca"></a>
                  </div>
                  <h3 class="fw-normal mb-3 pb-3" style="letter-spacing: 1px;"><strong>Ingrese su usuario y contraseña</strong></h3>
                  <div class="form-outline mb-4">
                    <input type="text" id="usuario" name="usuario" [(ngModel)]="usuario"  class="form-control form-control-lg" placeholder="Número Docente"/>
                  </div>
                  <div class="form-outline mb-4">
                    <input [type]="showPwd ? 'text' : 'password'" id="passw" name="passw" [(ngModel)]="passw" class="form-control form-control-lg" placeholder="Contraseña" />
                  </div>
                  <div class="contras">
                    <a id="verpwd" (click)="mostrarPwd()">{{showPwd ? 'Ocultar' : 'Mostrar'}} contraseña</a>
                  </div>
                  <div class="pt-1 mb-4">
                    <button id="btn-submit" class="btn-lg btn-block mt-3" type="submit" (click)="login()"><b>Entrar</b></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>